import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';

// Cylindo owns the AR panel inside its shadow root, so watch for <cylindo-ar>. Our
// floating controls have to hide while it's up or they cover its close button (CON-8444).
const useCylindoARActive = viewerId => {
  const $ = _c(11);
  const [isARActive, setIsARActive] = useState(false);
  const observerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = root => () => {
      const next = !!root.querySelector("cylindo-ar");
      setIsARActive(prev => prev === next ? prev : next);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const makeSync = t0;
  let t1;
  let t2;
  if ($[1] !== viewerId) {
    t1 = () => {
      const viewer = document.getElementById(viewerId);
      const root_0 = viewer?.shadowRoot;
      if (!root_0) {
        return;
      }
      const sync = makeSync(root_0);
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(root_0, {
        childList: true,
        subtree: true
      });
      observerRef.current = observer;
      return () => {
        observer.disconnect();
        observerRef.current = null;
      };
    };
    t2 = [viewerId, makeSync];
    $[1] = viewerId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== viewerId) {
    t3 = () => {
      if (observerRef.current) {
        return;
      }
      const root_1 = document.getElementById(viewerId)?.shadowRoot;
      if (!root_1) {
        return;
      }
      const sync_0 = makeSync(root_1);
      sync_0();
      const observer_0 = new MutationObserver(sync_0);
      observer_0.observe(root_1, {
        childList: true,
        subtree: true
      });
      observerRef.current = observer_0;
    };
    $[4] = viewerId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const rearm = t3;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
    };
    t5 = [];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== isARActive || $[9] !== rearm) {
    t6 = {
      isARActive,
      rearm
    };
    $[8] = isARActive;
    $[9] = rearm;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default useCylindoARActive;